import * as paths from 'adminConstants/routes';
import { AdminUserRealm } from 'further-types/admin-user';
import useAuth from 'hooks/auth/useAuth';
import { matchPath, useLocation } from 'react-router-dom';

const newLayoutPages: Array<string> = [
  paths.VEHICLES,
  paths.VEHICLE_ADD,
  paths.LP_COMPANY_LIST,
  paths.LP_REALISATION_LIST,
  paths.LP_ONBOARDING,
  paths.LP_FIRM_SETTINGS,
  paths.LP_CAPITAL_ACTION_LIST,
  paths.LP_CAPITAL_ACTION_NOTICE_CREATE,
  paths.USER_MANAGEMENT,
  paths.INCOME_OR_EXPENSE_LIST,
  paths.LP_INVESTMENT_LIST,
  paths.LP_INVESTMENT_CREATE,

  // not fully designed
  paths.FUND_SETUP,
  paths.COMMITMENTS_VIEW,
  paths.COMMITMENTS,
  paths.LP_PROFILE,
  paths.ADD_BANK_ACCOUNT,
  paths.BANK_RECONCILIATION,
  paths.PROCESS_BANK_ACCOUNT,
  paths.IMPORT_STATEMENT_FILE,
  paths.LP_CAPITAL_ACTION_CREATE,
];

const newLayouMatches = [
  paths.COMMITMENTS_VIEW,
  paths.LP_CAPITAL_ACTION_NOTICE_CREATE,
  paths.IMPORT_STATEMENT_FILE,
  paths.LP_CAPITAL_ACTION_CREATE_SUCCESS,
  paths.INCOME_OR_EXPENSE_SUCCESS,
  paths.INCOME_OR_EXPENSE_EDIT,
  paths.INCOME_OR_EXPENSE_VIEW,
  paths.INCOME_OR_EXPENSE_ADD,
  paths.LP_INVESTMENT_VIEW,
  paths.LP_INVESTMENT_EDIT,
  paths.LP_INVESTMENT_SUCCESS,
];

export default function useIsNewLayoutPage() {
  const { realm } = useAuth();
  const { pathname } = useLocation();

  if (realm !== AdminUserRealm.Lp) {
    return false;
  }

  const isRouteMatch = newLayouMatches.some((path) =>
    matchPath(pathname, { path }),
  );

  return isRouteMatch || newLayoutPages.includes(pathname);
}
